var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Marker, Popup } from "mapbox-gl";
import MapMarker from "../base/MapMarker";
var MapboxMarker = /** @class */ (function (_super) {
    __extends(MapboxMarker, _super);
    function MapboxMarker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MapboxMarker.prototype.createMarkerInternal = function () {
        var iconContainer = document.createElement('div');
        iconContainer.classList.add('marker');
        iconContainer.style.backgroundImage = "url(".concat(this.icon.iconUrl, ")");
        iconContainer.style.backgroundSize = '100%';
        iconContainer.style.width = "".concat(this.icon.iconSize[0], "px");
        iconContainer.style.height = "".concat(this.icon.iconSize[1], "px");
        var marker = new Marker(iconContainer, {
            anchor: 'bottom',
            offset: this.icon.iconAnchor
        }).setLngLat(this.location.toLngLat());
        if (this.hasPopup()) {
            var popup = new Popup({
                offset: this.icon.popupAnchor
            }).setHTML(this.generatePopupContent());
            marker.setPopup(popup);
        }
        return marker;
    };
    MapboxMarker.prototype.addTo = function (map) {
        this.marker.addTo(map.map);
        return this;
    };
    MapboxMarker.prototype.show = function () {
        this.marker.getElement().style.display = '';
    };
    MapboxMarker.prototype.hide = function () {
        this.marker.getElement().style.display = 'none';
        this.hidePopup();
    };
    MapboxMarker.prototype.remove = function () {
        this.marker.remove();
    };
    MapboxMarker.prototype.showPopup = function () {
        var _a;
        if (!((_a = this.marker.getPopup()) === null || _a === void 0 ? void 0 : _a.isOpen()))
            this.marker.togglePopup();
    };
    MapboxMarker.prototype.hidePopup = function () {
        var _a;
        if ((_a = this.marker.getPopup()) === null || _a === void 0 ? void 0 : _a.isOpen())
            this.marker.togglePopup();
    };
    return MapboxMarker;
}(MapMarker));
export default MapboxMarker;
